/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AbstractRoleParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['name', codecString],
]);
export class AbstractRole extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AbstractRoleParser.decode(input).map(res => new AbstractRole(res));
    }
    static unsafeDecode(input) {
        return AbstractRole.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AbstractRoleParser.encode(data);
    }
    static schema() {
        return AbstractRoleParser.schema();
    }
}
